module.exports = __webpack_public_path__ + "img/abstract-shapes-lego3.f1888591.svg";